import Actions from '../action/index';
const {
  RECEIVE_PRODUCT_LIST,
  ADD_ORDER_PRODUCT,
  ADD_ORDER_PRODUCTS,
  DELETE_ORDER_PRODUCT,
  SET_DISCOUNT,
  SET_CUSTOM_DISCOUNT,
  SET_SETTING_DISCOUNT,
  SET_QUANTITY,
  SET_INITIAL_PRODUCT_ORDER_LIST,
  SET_CUSTOM_DESCRIPTION,
  SET_PRODUCT_RATE,
  SET_AMOUNT,
} = Actions.product;

export const productList = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_PRODUCT_LIST:
      return action.productList;
    default:
      return state;
  }
};

export const productOrderList = (state = [], action) => {
  switch (action.type) {
    case ADD_ORDER_PRODUCT:
      return [
        ...state,
        {
          id: action.id,
          product: action.product,
          productModel: action.productModel,
          quantity: action.quantity,
          discount: action.discount,
          isCustomDiscount: action.isCustomDiscount,
          SOIID: action.SOIID,
          serials: action.serials,
          customDescription: action.customDescription || '',
          amount: action.amount,
          // 새로 고른 상품은 저장된 단가가 없다. 현재 정가로 계산되고,
          // 저장 시점에 그 단가가 주문에 기록된다.
          rate: null,
        },
      ];
    case ADD_ORDER_PRODUCTS:
      return [
        ...state,
        ...action.productOrders.map((productOrder) => ({
          ...productOrder,
          customDescription: productOrder.customDescription || '',
        })),
      ];
    case DELETE_ORDER_PRODUCT:
      return state.filter((productOrder) => {
        if (productOrder.id === action.id) return false;
        return true;
      });
    case SET_DISCOUNT:
      // 자동 할인 티어(수량/금액 합계 기준)가 바뀌면 커스텀 할인이 아닌 항목의
      // discount를 갱신한다. 이때 저장된 amount를 그대로 두면 화면에는 새 할인율이
      // 표시되지만 금액은 이전 할인율 기준 저장값이 유지되어 불일치가 생기므로
      // (SOK-I0822-1 사례), 할인율이 실제로 바뀐 항목은 amount를 비워 재계산되게 한다.
      // applyToLines가 false면 전역 할인율만 갱신하고 항목은 그대로 둔다.
      if (action.applyToLines === false) return state;
      return state.map((productOrder) =>
        productOrder.isCustomDiscount ||
        Number(productOrder.discount) === Number(action.discount)
          ? productOrder
          : {
              ...productOrder,
              discount: action.discount,
              amount: null,
            }
      );
    case SET_CUSTOM_DISCOUNT:
      return state.map((productOrder) =>
        productOrder.id === action.id
          ? {
              ...productOrder,
              discount: action.discount,
              isCustomDiscount: true,
              amount: null,
            }
          : productOrder
      );
    case SET_SETTING_DISCOUNT:
      return state.map((productOrder) =>
        productOrder.id === action.id &&
        Number(productOrder.discount) !== Number(action.discount)
          ? {
              ...productOrder,
              discount: action.discount,
              amount: null,
            }
          : productOrder
      );
    case SET_QUANTITY:
      return state.map((productOrder) =>
        productOrder.id === action.id
          ? { ...productOrder, quantity: action.quantity, amount: null }
          : productOrder
      );
    case SET_CUSTOM_DESCRIPTION:
      return state.map((productOrder) =>
        productOrder.id === action.id
          ? { ...productOrder, customDescription: action.customDescription }
          : productOrder
      );
    case SET_PRODUCT_RATE:
      return state.map((productOrder) =>
        productOrder.id === action.id
          ? {
              ...productOrder,
              product: {
                ...productOrder.product,
                [action.currency === 'KRW' ? 'KRWRetail' : 'USDRetail']:
                  action.rate,
              },
            }
          : productOrder
      );
    case SET_AMOUNT:
      return state.map((productOrder) =>
        productOrder.id === action.id
          ? { ...productOrder, amount: action.amount }
          : productOrder
      );
    case SET_INITIAL_PRODUCT_ORDER_LIST:
      return [];
    default:
      return state;
  }
};

export const discount = (state = 0, action) => {
  switch (action.type) {
    case SET_DISCOUNT:
      return action.discount;
    default:
      return state;
  }
};

// 목록이 저장된 SO/Invoice에서 통째로 불러와진 것인지 여부.
// true면 항목마다 저장 당시 확정된 할인율/금액이 들어 있으므로,
// 화면을 여는 것만으로 자동 할인 티어가 그 값을 덮어쓰면 안 된다.
export const isHydratedOrder = (state = false, action) => {
  switch (action.type) {
    case ADD_ORDER_PRODUCTS:
      return true;
    case SET_INITIAL_PRODUCT_ORDER_LIST:
      return false;
    default:
      return state;
  }
};
